import axios from 'axios';
import CONSTS from '../../config/constants';
import Env from '../../config/environment';

const env = Env();
const version = env.app.version;
const { API_APP } = CONSTS.SERVICES;

export const getCoupons = (params) => axios.get(`/b/docs/${version}/coupons?page=${params.page}&limit=${params.limit}`, {
  headers: {
    service: API_APP,
  },
});

export const createNewCoupon = (params) => axios.post(`/b/docs/${version}/coupons`, {
  ...params
}, {
  headers: {
    service: API_APP,
  },
});

export const edit = (params) => axios.post(`/b/docs/${version}/coupons/${params.id}/edit`, {
  active: params.active
}, {
  headers: {
    service: API_APP,
  },
});

export const remove = (id) => axios.delete(`/b/docs/${version}/coupons/${id}`, {
  headers: {
    service: API_APP,
  },
});

export const validate = (params) => axios.post(`/b/docs/${version}/coupons/${params.code}/validate`, {
  rut: params.rut,
}, {
  headers: {
    service: API_APP,
  },
});

export const consume = (params) => axios.post(`/b/docs/${version}/coupons/${params.code}/consume`, {
  rut: params.rut,
  docId: params.id
}, {
  headers: {
    service: API_APP,
  },
});